export const DefaultResponseProduct = {
  period:  {},
  concept: '',
  request: {}
}
